import ContentLoader from 'react-content-loader';

const MyLoader = () => (
  <div style={{
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: 60,
  }}
  >
    {[1, 2, 3, 4, 5].map(() => (
      <>
        <ContentLoader
          height={80}
          speed={1}
          style={{ marginBottom: 20 }}
          animate
          backgroundColor="#e0e0e0"
          foregroundColor="#f5f5f5"
          viewBox="0 0 380 70"
        >
          <rect x="0" y="0" rx="5" ry="5" width="70" height="70" />
          <rect x="80" y="7" rx="4" ry="4" width="300" height="13" />
          <rect x="80" y="40" rx="3" ry="3" width="250" height="10" />
        </ContentLoader>
      </>
    ))}
  </div>
);
export default MyLoader;
